import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">ELİT AYDIN PREFABRİK & KONTEYNER YAPI SİSTEMLERİ</h3>
            <p className="footer-description">
              Profesyonel prefabrik ve konteyner yapı çözümleri ile hayallerinizdeki yapıyı 
              gerçeğe dönüştürüyoruz. Kalite, güvenilirlik ve müşteri memnuniyeti 
              odaklı hizmet anlayışımızla yanınızdayız.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Hızlı Linkler</h4>
            <ul className="footer-links">
              <li><Link to="/">Ana Sayfa</Link></li>
              <li><Link to="/hakkimizda">Hakkımızda</Link></li>
              <li><Link to="/hizmetlerimiz">Hizmetlerimiz</Link></li>
              <li><Link to="/projelerimiz">Projelerimiz</Link></li>
              <li><Link to="/iletisim">İletişim</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Hizmetlerimiz</h4>
            <ul className="footer-links">
              <li>Prefabrik Evler</li>
              <li>Prefabrik Villalar</li>
              <li>Modül Ev</li>
              <li>Konteyner Ev</li>
              <li>Endüstriyel Yapılar</li>
              <li>Özel Tasarım Konteyner</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">İletişim</h4>
            <ul className="footer-contact">
              <li>
                <span className="contact-icon">📍</span>
                <span>Sandıklı, 09600 İncirliova/Aydın, Türkiye</span>
              </li>
              <li>
                <span className="contact-icon">📞</span>
                <span>
                  <a href="tel:+905442575285" className="footer-phone-link">0544 257 52 85</a>
                </span>
              </li>
              <li>
                <span className="contact-icon">📞</span>
                <span>
                  <a href="tel:+905442500813" className="footer-phone-link">0544 250 08 13</a>
                </span>
              </li>
              <li>
                <span className="contact-icon">✉️</span>
                <span>info@prefabrik.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Elit Aydın Yapı Çözümleri. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

